import { useTranslation, untranslated } from "@i18n";
import { BUTTON_TYPES } from "@CubeComponents/constants/globalVariable";
import ButtonComponent from "@CubeComponents/form/ButtonComponent/index";
import ModalStateDialogComponent from "@CubeComponents/html/modal/ModalWithState";
import { useRef } from "react";
import Forms from "./index.js";
import { showToastNotification } from "@Reducers/toastSlice";
import { useDispatch } from "react-redux";
import { TOAST_TYPE_ERROR, TOAST_TYPE_SUCCESS } from "@Services/constants.js";
import { projectTemplateConfigHandler } from "@Actions/projectSetting.js";
import { useParams } from "react-router-dom";
import Text from "@CubeComponents/html/Text/Text.js";
import type { ObjectIdString } from "@Helpers/schemas/common.schema";

function ProjectTemplateConfig({ formCategory, source, setShowTemplatesGrid, refreshGrid }: any) {
  const { t } = useTranslation();
  const dataGrid: any = useRef<any>(null);
  const dispatch = useDispatch();
  // Route params enter from outside the type system; the backend route schema validates this id.
  const params = useParams<{ projectId: ObjectIdString }>();

  const handleAddTemplate = async () => {
    const selectedRecords = dataGrid.current.dataView.getAllSelectedItems();
    if (selectedRecords.length && params.projectId) {
      const templateIds = selectedRecords.map((obj: any) => obj._id);
      const res = await projectTemplateConfigHandler({
        action: "add" as const,
        templateIds,
        projectId: params.projectId,
      });

      setShowTemplatesGrid(false);
      if (res.data.status) {
        dispatch(
          showToastNotification({
            content: t("Template(s) added successfully"),
            type: TOAST_TYPE_SUCCESS,
          }),
        );
        refreshGrid();
      } else {
        dispatch(
          showToastNotification({
            content: untranslated(res.data.errorMessage ?? "An error occurred"),
            type: TOAST_TYPE_ERROR,
          }),
        );
      }
    } else {
      dispatch(
        showToastNotification({
          content: t("Select template first to add them to this project"),
          type: TOAST_TYPE_ERROR,
        }),
      );
    }
  };

  return (
    <ModalStateDialogComponent
      allowModalPadding={false}
      isVisible
      height={"80%"}
      onCancel={() => setShowTemplatesGrid(false)}
      headerTitle={<Text className=" w-full justify-between flex">{t("Select Template")}</Text>}
      footerContent={
        <div className="">
          <ButtonComponent onClick={handleAddTemplate} buttonType={BUTTON_TYPES.BACKGROUND_BUTTON}>
            <Text>{t("Add")}</Text>
          </ButtonComponent>
        </div>
      }
      modelContent={
        <Forms
          excludeTemplates={true}
          source={source}
          ref={dataGrid}
          formCategory={formCategory}
          showOnlyGrid
          projectId={params.projectId}
        />
      }
      width="80%"
    />
  );
}
export default ProjectTemplateConfig;
